import React, { useState, useEffect } from "react";
import axios from "axios";
import ContentArea from "./ContentArea";
import "../styles/styles.css";
import { toast } from 'react-toastify'; // ✅ Import toast
import 'react-toastify/dist/ReactToastify.css'; // ✅ Import the toast styles
import Loader from '../loader'; // Import the loader
const Deck = () => {
  // ========================== State Management ==========================
  const [focusedPostId, setFocusedPostId] = useState(null);
  const [hasMore, setHasMore] = useState(true); // Determines if there are more pages to load
  const [loading, setLoading] = useState(false); // Tracks if data is being fetched
  const [page, setPage] = useState(1); // Tracks the current page
  const [columns, setColumns] = useState([]); // Stores the list of columns
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [mainloading, mainsetLoading] = useState(false);
  // API Endpoint
  const endpoint = "api/deck/";
  const [sortOrder, setSortOrder] = useState(null);  // Track sorting order globally


  
  // ========================== Effect Hooks ==========================

  useEffect(() => {
    const storedColumns = [];
  
    let index = 0;
    while (localStorage.getItem(`searchInput-${index}`) !== null) {
      const storedColumn = {
        searchKeyword: localStorage.getItem(`searchInput-${index}`) || "",
        selectedPlatforms: JSON.parse(localStorage.getItem(`selectedPlatforms-${index}`)) || [],
        fromDate: localStorage.getItem(`fromDate-${index}`) === "none" ? "" : localStorage.getItem(`fromDate-${index}`),
        toDate: localStorage.getItem(`toDate-${index}`) === "none" ? "" : localStorage.getItem(`toDate-${index}`),
        posts: [],
        initialPosts: [],
        isExpanded: false,
        editableTitle: false,
      };
  
      storedColumns.push(storedColumn);
      index++;
    }
  
    if (storedColumns.length > 0) {
      setColumns(storedColumns);
  
      // **Check for valid keyword & platform before fetching**
      storedColumns.forEach((column, colIndex) => {
        if (column.searchKeyword.trim() && column.selectedPlatforms.length > 0) {
          fetchData(colIndex, 1, column.searchKeyword, column.fromDate, column.toDate, column.selectedPlatforms);
        }
      });
    }
  }, []);
  
  // **Step 3: Persist Search Inputs in Local Storage**
  useEffect(() => {
    columns.forEach((column, index) => {
      localStorage.setItem(`searchInput-${index}`, column.searchKeyword);
      localStorage.setItem(`selectedPlatforms-${index}`, JSON.stringify(column.selectedPlatforms));
      localStorage.setItem(`fromDate-${index}`, column.fromDate ? column.fromDate : "none");
      localStorage.setItem(`toDate-${index}`, column.toDate ? column.toDate : "none");
    });
  }, [columns]);

  // useEffect(() => {
  //   // Function to fetch data every 5 minutes (300,000 milliseconds)
  //   const intervalId = setInterval(() => {
  //     // Loop over all columns and fetch data if the search keyword exists
  //     columns.forEach((column, colIndex) => {
  //       if (column.searchKeyword.trim()) {
  //         // Call your search function or API request to fetch new data
  //         // Example: apihandleSearch(column.searchKeyword, colIndex, column.selectedPlatforms);
  
  //         // If you have a specific function to fetch data, call it here
  //         // For example:
  //         apihandleSearch(column.searchKeyword, colIndex, column.selectedPlatforms);
  //       }
  //     });
  //   }, 300000); // 5 minutes in milliseconds (300,000 ms)
  
  //   // Clean up the interval when the component is unmounted
  //   return () => clearInterval(intervalId);
  // }, [columns]); // Dependency array - runs whenever `columns` change
  
  


  useEffect(() => {
    // Function to auto-fetch data from localStorage every 5 seconds
    const intervalId = setInterval(() => {
      columns.forEach((column, colIndex) => {
        if (column.searchKeyword.trim()) {
          apihandleSearch(column.searchKeyword, colIndex, column.selectedPlatforms);
          fetchDataPeriodically(colIndex, column.searchKeyword, column.fromDate, column.toDate);
          // Call apihandleSearch after 4 minutes
        }
      });
    }, 180000); // Every 5 seconds

    // Clean up the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [columns]); // Run the interval whenever `c


  // useEffect(() => {
  //   // Function to auto-fetch data from localStorage every 4 minutes
  //   const intervalId = setInterval(() => {
  //     columns.forEach((column, colIndex) => {
  //       if (column.searchKeyword.trim()) {
  
  //         // Call apihandleSearch after 4 minutes
  //         apihandleSearch(column.searchKeyword, colIndex, column.selectedPlatforms);
  //       }
  //     });
  //   }, 180000); // Every 2 minutes (240,000 milliseconds)
  
  //   // Clean up the interval when the component is unmounted
  //   return () => clearInterval(intervalId);
  // }, [columns]); // Run the interval whenever `columns` change

  // ========================== Fetch Data Periodically ==========================
  const fetchDataPeriodically = async (index, searchKeyword, fromDate, toDate) => {
    // Fetch data every 5 seconds based on parameters stored in localStorage
    if (!searchKeyword.trim()) return;

  
    try {
      let url = `${endpoint}?query=${encodeURIComponent(searchKeyword)}&page=1`;
      if (fromDate) url += `&fromDate=${fromDate}`;
      if (toDate) url += `&toDate=${toDate}`;

      const response = await axios.get(url);

      if (response.data.results && Array.isArray(response.data.results)) {
        const newPosts = response.data.results.map((post) => ({
          ...post.fields,
          id: post.pk,
          model: post.model,
          platform: post.platform,
        }));

        // Update the column with fetched data
        setColumns((prevColumns) => {
          const updatedColumns = [...prevColumns];
          updatedColumns[index].posts = newPosts;
          updatedColumns[index].initialPosts = newPosts;
          return updatedColumns;
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {

    }
  };

  // ==========================Fetching Functions ==========================

  const fetchData = async (index, pageNum, keyword = "", fromDate = "", toDate = "", selectedPlatforms = "") => {
    if (!keyword.trim()) {
        toast.error("Please enter a keyword.");
        return;
    }
    mainsetLoading(true);
    setIsLoading(true);
    try {
        // Construct the URL for fetching posts based on the search query
        let url = `${endpoint}?page=${pageNum}&query=${encodeURIComponent(keyword)}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;

        const response = await axios.get(url);

        if (response.data.results && Array.isArray(response.data.results)) {
            const newPosts = response.data.results.map((post) => ({
                ...post.fields,
                id: post.pk,
                model: post.model,
                platform: post.platform,
            }));

            // Update the column with fetched data
            setColumns((prevColumns) => {
                const updatedColumns = [...prevColumns];
                updatedColumns[index].posts = newPosts;
                updatedColumns[index].initialPosts = newPosts;
                return updatedColumns;
            });
        }
        toast.success("Data fetched successfully from Database!");
    } catch (error) {
        console.error("Error fetching data:", error);
    } finally {
        setIsLoading(false);
        mainsetLoading(false);
    }
};



const apihandleSearch = async (keyword, index, selectedPlatforms) => {
  if (!keyword.trim() || selectedPlatforms.length === 0) {
    toast.error("Please enter a keyword and select at least one platform.");
    return;
  }

  try {
    const response = await axios.post("api/keyword/", {
      keyword: keyword,
      platforms: selectedPlatforms,
      columnIndex: index,
    });
  } catch (error) {
    console.error("Error fetching search results:", error);
  }
};



  // ========================== Fetching Functions ==========================


  // Loads more posts when user scrolls or clicks "Load More"

const handleLoadMore = async (colIndex) => {
  const currentColumn = columns[colIndex];
  const keyword = currentColumn.searchKeyword;
  const nextPage = page + 1;

  if (!keyword.trim()) return;  // Check if the keyword is not just whitespace

  mainsetLoading(true); // Set mainloading to true when starting to load more data

  try {
    let url = `${endpoint}?page=${nextPage}&query=${encodeURIComponent(keyword)}`;
    const response = await axios.get(url);

    const newPosts = response.data.results.map((post) => ({
      ...post.fields,
      id: post.pk,
      model: post.model,
      platform: post.platform,
    }));

    const parsedConditions = parseSearchQuery(keyword);
    const highlightedPosts = newPosts.map((post) => ({
      ...post,
      highlightedText: highlightText(post.text, parsedConditions.flatMap((condition) => condition.keywords)),
    }));

    setColumns((prevColumns) => {
      const updatedColumns = [...prevColumns];
      updatedColumns[colIndex].posts = [...updatedColumns[colIndex].posts, ...highlightedPosts];
      return updatedColumns;
    });

    setPage(nextPage); // Update the page number after successfully loading more posts
  } catch (error) {
    console.error("Failed to load more posts:", error);
  } finally {
    mainsetLoading(false); // Set mainloading to false after loading is complete or failed
  }
};

  

  const handleSearch = (index, keyword, fromDate, toDate, selectedPlatforms = null) => {
    setColumns((prevColumns) => {
      const updatedColumns = [...prevColumns];

      updatedColumns[index].selectedPlatforms = selectedPlatforms !== null
        ? selectedPlatforms
        : prevColumns[index].selectedPlatforms;

      updatedColumns[index].searchKeyword = keyword;
      updatedColumns[index].fromDate = fromDate ? fromDate : "none";
      updatedColumns[index].toDate = toDate ? toDate : "none";

      if (keyword.trim()) {
        fetchData(index, 1, keyword, fromDate, toDate, updatedColumns[index].selectedPlatforms);
        
      } else {
        updatedColumns[index].posts = [];
        updatedColumns[index].initialPosts = [];
      }

      return updatedColumns;
    });
  };


  

  // ========================== Utility Functions ==========================

  // Parses a search query into structured conditions
  const parseSearchQuery = (query) => {
    // Split the query by spaces and commas, but allow multi-word phrases wrapped in quotes
    const keywordPattern = /"([^"]+)"|([^,\s]+)/g;
    const keywords = [];
    let match;
  
    // Find all keywords and multi-word phrases
    while ((match = keywordPattern.exec(query)) !== null) {
      // If there's a quoted phrase, use that as a whole keyword
      if (match[1]) {
        keywords.push(match[1].trim());
      } else {
        keywords.push(match[2].trim());
      }
    }
  
    let conditions = [];
    let currentCondition = [];
    let operator = "OR"; // Default operator is OR
  
    // Process the keywords and split by AND/OR operators
    keywords.forEach((keyword) => {
      const normalizedKeyword = keyword.trim().toUpperCase();
  
      if (normalizedKeyword === "AND" || normalizedKeyword === "OR") {
        if (currentCondition.length) {
          conditions.push({ operator, keywords: currentCondition });
          currentCondition = [];
        }
        operator = normalizedKeyword;
      } else {
        currentCondition.push(keyword);
      }
    });
  
    if (currentCondition.length) {
      conditions.push({ operator, keywords: currentCondition });
    }
  
    return conditions;
  };
  
  // Highlights matching keywords in a text
  const highlightText = (text, keywords) => {
    if (!keywords || keywords.length === 0 || !text) return text;
  
    // Create a regex that matches whole words (not substrings inside other words)
    const regexParts = keywords.map((keyword) => {
      // Escape any special characters in the keyword
      const escapedKeyword = keyword.replace(/[.*+?^=!:${}()|/\\]/g, "\\$&");
      // Match whole words or multi-word phrases surrounded by word boundaries
      return `\\b(${escapedKeyword})\\b`;
    });
  
    const regex = new RegExp(regexParts.join("|"), "gi");
  
    return text.split(regex).map((part, index) =>
      regex.test(part) && part.trim().length > 0 ? (
        <span key={index} className="highlight">
          {part.trim()}
        </span>
      ) : (
        part
      )
    );
  };
  
  // ========================== Event Handlers ==========================

  // Toggles focus on a post
  const handleFocus = (postId) => {
    setFocusedPostId((prevId) => (prevId === postId ? null : postId));
  };

  // Adds a new column
  const handleAddColumn = async () => {
    setIsLoading(true);

    setColumns((prevColumns) => [
      ...prevColumns,
      {
        // keyword: "",
        posts: [],
        initialPosts: [],
        isExpanded: false,
        searchKeyword: "",
        editableTitle: false,
        selectedPlatforms: [],
        fromDate: "",
        toDate: "",
      },
    ]);

    setIsLoading(false);
  };

  // Clears focus when clicking outside
  const handleClickOutside = () => {
    setFocusedPostId(null);
  };

  // Toggles edit mode for column title
  const toggleTitleEdit = (index) => {
    setColumns((prevColumns) =>
      prevColumns.map((column, idx) =>
        idx === index ? { ...column, editableTitle: !column.editableTitle } : column
      )
    );
  };

  // Handles title change when user finishes editing
  const handleBlur = (index, newTitle) => {
    setColumns((prevColumns) =>
      prevColumns.map((column, idx) =>
        idx === index
          ? { ...column, keyword: newTitle.trim() ? newTitle : "Untitled Column", editableTitle: false }
          : column
      )
    );
  };

  // ========================== Render Component ==========================

  return (
    <div className="deck" onClick={handleClickOutside}>
       {mainloading && <Loader />} {/* Display loader while loading */}
      <ContentArea
        columns={columns}
        fetchData={fetchData}
        handleAddColumn={handleAddColumn}
        handleFocus={handleFocus}
        focusedPostId={focusedPostId}
        toggleTitleEdit={toggleTitleEdit}
        handleBlur={handleBlur}
        setColumns={setColumns}
        handleLoadMore={handleLoadMore}
        loading={loading}
        hasMore={hasMore}
        handleSearch={handleSearch}
        isLoading={isLoading}
        apihandleSearch = {apihandleSearch}
        
      />
    </div>
  );
};

export default Deck;
